import { loginByUsername, logout, getUserInfo, loadDrawer } from '../../services/userservice'
import { getToken, setToken, removeToken } from '../../utils/auth'
import { setRoutes } from './../../router'

const user = {
  state: {
    usuario: {},
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    home_page: '',
    roles: [],
    routers: [],
    drawer: [],
    setting: {
      articlePlatform: []
    },
    operations: []
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USER: (state, user) => {
      state.usuario = user
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ROUTERS: (state, routers) => {
      state.routers = routers
    },
    SET_DRAWER: (state, drawer) => {
      state.drawer = drawer
    },
    // eslint-disable-next-line camelcase
    SET_HOMEPAGE: (state, home_page) => {
      // eslint-disable-next-line camelcase
      state.home_page = home_page
    }
  },

  actions: {
    // Login por nome do usuário
    LoginByUsername ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginByUsername(userInfo).then(resp => {
          if (resp.status === 200) {
            commit('SET_TOKEN', resp.data.token)
            commit('SET_USER', resp.data.user)
            // commit('SET_ROLES', data.msg.routes)
            setToken(resp.data.token)
            // setRoles(data.routes)
            resolve(resp)
          } else {
            resolve(resp)
          }
        }).catch(error => {
          reject(error)
          return false
        })
      })
    },

    LoadMenus ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_DRAWER', { op: 1, nome: 'Obrigado', icon: 'book' })
        commit('SET_HOMEPAGE', 'obrigado')
        setRoutes([{ op: 1, nome: 'Obrigado', icon: 'book' }], 'obrigado')
        resolve({ msg: 'ok' })
      })
    },
    // Obter informações do usuário
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          if (!response.data) {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('error')
          }
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // Sair
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve({ msg: 'ok' })
        }).catch(error => {
          reject(error)
        })
      })
    },

    // Front end
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // Modifique dinamicamente as permissões
    ChangeRoles({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve()
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/usermodule.js